module.exports = __webpack_public_path__ + "static/image142-ceb8d40e4bf21e16aae2817fc338b99c.jpg";